import { rm } from '../../copyR3Money'

/** R-47: the disclosure shown right under an affiliate link, before anyone clicks it (FTC: clear and next to the link). */
export function AffiliateNote() {
  return <p data-review-id="affiliate-note" className="t-meta mt-1 text-ink-2">{rm('rm.affiliate_note')}</p>
}
